import { AbstractEntity } from "../AbstractEntity";
export const HEAD_OF_BOOK_ROLE_PREFIX = 'headOf_';
export const ACCESS_TO_BOOK_ROLE_PREFIX = 'accessTo_';
export default class Role extends AbstractEntity {
    name;
    rules;
    constructor(role = {}) {
        super();
        Object.assign(this, role);
    }
}
const ROLE_HIERARCHIES = ['viewer', 'operator', 'master', 'admin', 'service'];
export function getRoleHierarchy(role) {
    return ROLE_HIERARCHIES.indexOf(role.name);
}
export function getHighestRoleHierarchy(roles) {
    return Math.max(...roles.map(getRoleHierarchy));
}
export function getHighestRoleName(roles) {
    return ROLE_HIERARCHIES[getHighestRoleHierarchy(roles)];
}
//# sourceMappingURL=Role.js.map